import { defineStore } from 'pinia'
import { inject, ref } from 'vue'

const tokenName = import.meta.env.VITE_APP_TOKEN_NAME

// https://pinia.vuejs.org/core-concepts/#Setup-Stores
export const useUserStore = defineStore('user', () => {
  const $axios = inject('$axios')

  const loginInfo = ref({})

  async function login(payload) {
    try {
      const { status, data } = await $axios.post('/api/adm/auth/login', {
        admin_id: payload.userName,
        admin_pw: payload.password,
      })

      if (data.token) {
        localStorage.setItem(tokenName, data.token)
      }

      return { status, data }
    } catch (err) {
      const { status, data } = err.response

      localStorage.removeItem(tokenName)
      return { status, data }
    }
  }

  async function getLogin() {
    // const { data } = await $axios.get('/api/admin/profile')
    // loginInfo.value = data.query || {}
  }

  async function updateLogin(payload) {
    // try {
    //   const { status, data } = await $axios.post('/api/admin/profile', payload)
    //   return { status, data }
    // } catch (err) {
    //   const { status, data } = err.response
    //   return { status, data }
    // }
  }

  return {
    loginInfo,
    getLogin,
    updateLogin,
    login,
  }
})
